<template>
  <div>
      <h1>Concesionarios Sin Viajes Disponibles</h1>
        <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Filtro" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar..."></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getConcesionarioWithoutTripsAvailable"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getConcesionarioWithoutTripsAvailable.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
// import { encrypt } from '@/config/headers'
export default {
  data() {
    return {
      getConcesionarioWithoutTripsAvailable: [],
      fields: [
        { key: 'name', label: 'Concesionario', sortable: true, sortDirection: 'desc' },
        { key: 'email', label: 'Email' },
        { key: 'phoneNumber', label: 'Teléfono' },
        { key: 'rfc', label: 'RFC' },
        { key: 'address.city', label: 'Municipio' },
        { key: 'address.state', label: 'Estado' },
        { key: 'address.suburb', label: 'Colonia' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
    }
  },
  apollo: {
    getConcesionarioWithoutTripsAvailable: {
      query: gql`
      query {
          getConcesionarioWithoutTripsAvailable {
            id
            name
            email
            phoneNumber
            rfc
            address{
            id
            city
            state
            suburb
            }
            tripsAvailable
            active
        }
      }`,
      context: {
        // headers: encrypt(new Date().getTime()),
      },
      error (erro) {
        console.log(erro)
      },
      result ({ data }) {
        if (data.getConcesionarioWithoutTripsAvailable != null) {
          this.totalRows = data.getConcesionarioWithoutTripsAvailable.length
        }
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style>

</style>
